import * as React from 'react';
import { TogglePill } from '@gandi/ui';
import NullDecorator from '../decorators/NullDecorator';
import FormField from '../wrappers/FormField';
import decorateControl from '../wrappers/decorateControl';
import { jsx as _jsx } from "react/jsx-runtime";
function TogglePillCompat(_props) {
  const {
    isField,
    ...props
  } = _props;
  return /*#__PURE__*/_jsx(TogglePill, {
    ...props
  });
}
const component = decorateControl(TogglePillCompat, NullDecorator);
const TogglePillField = props => /*#__PURE__*/_jsx(FormField, {
  ...props,
  component: component
});
export default TogglePillField;